class SmartBundle extends HTMLElement {
  constructor() {
    super();
    this.discountPct = parseInt(this.dataset.bundleDiscount || '0', 10);
  }

  connectedCallback() {
    this.form = this.querySelector('[data-bundle-form]');
    this.cta = this.querySelector('[data-bundle-submit]');
    this.totalEl = this.querySelector('[data-bundle-total]');
    this.beforeEl = this.querySelector('[data-bundle-before]');
    this.saveEl = this.querySelector('[data-bundle-save]');
    const cur = this.querySelector('[data-bundle-current] [data-bundle-price]');
    this.currentPrice = cur ? (parseInt(cur.dataset.bundlePrice, 10) || 0) : 0;
    this.currentVariantId = this.findCurrentVariantId();

    this.form.addEventListener('change', () => this.updateTotals());
    this.cta.addEventListener('click', () => this.addToCart());
    this.updateTotals();
  }

  findCurrentVariantId() {
    const productForm = document.querySelector('product-form form, form[action*="/cart/add"]');
    if (productForm) {
      const idInput = productForm.querySelector('[name="id"]');
      if (idInput) return idInput.value;
    }
    return null;
  }

  updateTotals() {
    let total = this.currentPrice;
    const partners = this.querySelectorAll('[data-bundle-partner]');
    let selectedCount = 1;
    partners.forEach(li => {
      const cb = li.querySelector('.smart-bundle__native-checkbox');
      if (cb && cb.checked) {
        total += parseInt(cb.dataset.bundlePrice, 10) || 0;
        selectedCount++;
      }
    });

    const discounted = this.discountPct > 0 ? Math.round(total * (100 - this.discountPct) / 100) : total;
    const save = total - discounted;

    if (this.totalEl) this.totalEl.textContent = this.formatMoney(discounted);
    if (save > 0) {
      if (this.beforeEl) this.beforeEl.textContent = this.formatMoney(total);
      if (this.saveEl) this.saveEl.textContent = `Save ${this.formatMoney(save)}`;
    } else {
      if (this.beforeEl) this.beforeEl.textContent = '';
      if (this.saveEl) this.saveEl.textContent = '';
    }

    const ctaText = this.cta && this.cta.querySelector('.smart-bundle__cta-text');
    if (ctaText) {
      ctaText.textContent = selectedCount > 1
        ? `Add ${selectedCount} items to cart`
        : 'Add to cart';
    }
  }

  formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, (window.theme && window.theme.money_format) || '${{amount}}');
    }
    const amount = (cents / 100).toFixed(2);
    const symbol = document.documentElement.lang === 'en-US' ? '$' : '€';
    return symbol + amount;
  }

  async addToCart() {
    const checked = this.querySelectorAll('.smart-bundle__native-checkbox:checked');
    const items = [];

    if (this.currentVariantId) {
      items.push({ id: this.currentVariantId, quantity: 1 });
    }
    checked.forEach(cb => {
      items.push({ id: cb.value, quantity: 1 });
    });

    if (items.length === 0) return;

    this.cta.setAttribute('disabled', '');
    const loader = this.cta.querySelector('.smart-bundle__cta-loader');
    if (loader) loader.hidden = false;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('Add failed');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      const drawer = document.getElementById('cart-drawer');
      if (drawer && drawer.open) drawer.open();
      if (!drawer) window.location.href = '/cart';
    } catch (e) {
      console.error(e);
      alert('Could not add items — please try again.');
    } finally {
      this.cta.removeAttribute('disabled');
      if (loader) loader.hidden = true;
    }
  }
}

if (!customElements.get('smart-bundle')) customElements.define('smart-bundle', SmartBundle);
